
    const data = {"name":"src/core/icons/drag-vertical-variant","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M11 21H9V3h2v18m4-18h-2v18h2V3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            